<header
  class="top-header mat-elevation-z5"
  [class.hidden]="toggleSearch"
  [ngClass]="{ test: getSideBarSate() }"
>
  <div class="flex-grow-1 gap-1 d-flex align-items-center">
    <button mat-icon-button (click)="toggleSidebar()">
      <mat-icon class="material-icons-outlined">menu</mat-icon>
    </button>
  </div>

  <div class="d-flex align-items-center gap-1">
    <button mat-icon-button (click)="darkMode()">
      <mat-icon class="material-icons-outlined">
        {{ getThemeIcon() }}
      </mat-icon>
    </button>
    <!-- <button mat-icon-button [matMenuTriggerFor]="Appmenu">
      <mat-icon class="material-icons-outlined">apps</mat-icon>
    </button>
    <mat-menu #Appmenu class="dropdown-apps rounded-4">
      <mat-grid-list cols="3" rowHeight="4:4">
        <mat-grid-tile *ngFor="let item of appIcon">
          <div class="app-box text-center">
            <div class="app-icon">
              <img src="{{item.src}}" width="30" alt="">
            </div>
            <div class="app-name">
              <p>{{item.name}}</p>
            </div>
          </div>
        </mat-grid-tile>
      </mat-grid-list>
    </mat-menu> -->

    <!-- <button mat-icon-button [matMenuTriggerFor]="Notification">
      <mat-icon class="material-icons-outlined" matBadge="7" matBadgePosition="after"
        matBadgeColor="warn">notifications</mat-icon>
    </button>
    <mat-menu #Notification class="rounded-4 dropdown-notification">
      <button mat-menu-item>
        <mat-icon class="material-icons-outlined text-red">shopping_cart</mat-icon>
        <span>New Sale from Gumroad</span>
      </button>
      <button mat-menu-item>
        <mat-icon class="material-icons-outlined text-purple">email</mat-icon>
        <span>Check your new message</span>
      </button>
      <button mat-menu-item>
        <mat-icon class="material-icons-outlined text-green">task</mat-icon>
        <span>You have 5 new task</span>
      </button>
      <button mat-menu-item>
        <mat-icon class="material-icons-outlined text-blue">supervisor_account</mat-icon>
        <span>10 New users registered</span>
      </button>
      <button mat-menu-item>
        <mat-icon class="material-icons-outlined text-amber">card_giftcard</mat-icon>
        <span>You have received 1 new gift</span>
      </button>
      <button mat-menu-item>
        <mat-icon class="material-icons-outlined text-teal">done_all</mat-icon>
        <span>Payment succesfully completed</span>
      </button>
      <div class="mx-3 my-2">
        <button mat-raised-button color="primary" class="rounded-4 w-100">View All</button>
      </div>
    </mat-menu> -->

    <button mat-icon-button [matMenuTriggerFor]="UserProfile">
      <mat-icon class="material-icons-outlined">account_circle</mat-icon>
    </button>
    <mat-menu #UserProfile class="rounded-4 dropdown-userprofile">
      <button
        mat-menu-item
        class="d-flex flex-column align-items-center text-center py-2"
      >
        <div class="d-flex flex-column align-items-center text-center py-2">
          <div
            class="initials-circle rounded-circle d-flex align-items-center justify-content-center text-white mb-2"
            style="
              width: 80px;
              height: 80px;
              background-color: #6c757d;
              font-size: 28px;
            "
          >
            {{ getInitials(adminData.adminName, adminData.adminLastName) }}
          </div>
        </div>
        <div>
          <h4 class="username mb-0">
            {{ adminData.adminName }}<br />{{ adminData.adminLastName }}
          </h4>
          <p class="mb-0">{{ adminData.adminEmail }}</p>
        </div>
      </button>
      <mat-divider></mat-divider>
      <button mat-menu-item>
        <mat-icon class="material-icons-outlined">account_circle</mat-icon>
        <span>Cuenta</span>
      </button>
      <button mat-menu-item>
        <mat-icon class="material-icons-outlined">settings</mat-icon>
        <span>Ajustes</span>
      </button>
      <mat-divider></mat-divider>
      <button mat-menu-item (click)="logOut()">
        <mat-icon class="material-icons-outlined">logout</mat-icon>
        <span>Cerrar sesión</span>
      </button>
    </mat-menu>
  </div>
</header>
